import styled from "styled-components";

export const Section = styled.div`
  padding: 0;
  margin: 0;
`;

export const SectionFooter = styled.div`
  margin: 20px 40px;
  text-align: left;

  @media print {
    display: none;
  }
`;

export const FooterDisclaimer = styled.span`
  display: block;
  font-size: .75rem;
  font-family: Inter;
  font-weight: 400;
  font-style: italic;
`;

export const FooterDate = styled.span`
  display: block;
  margin-top: 4px;
  font-size: .75rem;
  font-family: Inter;
  font-weight: 400;
  color: #aaa;
`;

/* Repeating footer shown on every printed page via position:fixed */
export const PrintRepeatFooter = styled.div`
  display: none;

  @media print {
    display: block;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 4px 20px;
    background: white;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
    border-top: 1px solid #ddd;
    font-size: 0.6rem;
    font-family: Inter, sans-serif;
    font-style: italic;
    color: #555;
  }
`;

export const PrintFooterDate = styled.span`
  display: none;

  @media print {
    display: block;
    margin-top: 1px;
    font-style: normal;
    color: #888;
  }
`;

export const PrintFooterPageNumber = styled.span`
  display: none;

  @media print {
    display: block;
    margin-top: 2px;
    font-style: normal;
    color: #888;
  }
`;

export const SectionLight = styled.div`
  background: rgb(255, 255, 255);
  padding: 0 0 0 40px;
`;

export const ReportContainer = styled.div`
  width: 100%;
`;

export const SectionDark = styled.div`
  background: rgb(236, 230, 238);
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
  margin-bottom: 0.5rem;
  padding: 0 0 0 40px;
`;

export const PageHeader = styled.h1`
  color: #482952;
  font-size: 1.25rem;
  font-family: Inter;
  font-weight: 800;
  line-height: 115%;
  letter-spacing: -0.02475rem;
  text-transform: uppercase;
  margin: 16px 0 8px 0;
`;

export const ReportDetail = styled.div`
  padding: 6px 0;

  @media print {
    page-break-inside: avoid;
    break-inside: avoid;
    padding-bottom: 30px; /* space above fixed print footer */
  }
`;

/* Section heading with full-width light purple background (body sections only) */
export const SectionHeading = styled.h2`
  color: #482952;
  font-size: 0.85rem;
  font-weight: 600;
  line-height: 1.3;
  padding: 3px 20px 3px 40px;
  margin: 0 0 3px -40px;
  background: #f0eaf4;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
`;

export const HeaderText = styled.h2`
  color: #482952;
  font-size: 0.85rem;
  font-weight: 600;
  line-height: 1.3;
  padding: 0px 0 3px 0;
`;

export const HeaderTextDark = styled.h2`
  color: #482952;
  font-size: 0.85rem;
  font-weight: 600;
  line-height: 1.3;
  padding: 0px 0 3px 0;
  background: rgb(236, 230, 238);
`;

export const LineText = styled.div`
  color: #000;
  font-size: .78rem;
  line-height: 1.4;
`;

export const LineTextBoxed = styled.div`
  color: #000;
  font-size: .78rem;
  border: 1px solid #000;
  padding: 2px 4px;
  width: 500px;
  line-height: 1.4;
`;

export const LineTextInd = styled.div`
  color: #000;
  font-size: .78rem;
  padding-left: 5px;
  line-height: 1.4;
`;

export const LineKey = styled.span`
  font-weight: 600;
  padding-right: 6px;
`;

export const LineVal = styled.span`
  padding-right: 25px;
`;

export const SubSection = styled.div`
  padding-bottom: 5px;
`;